import { useMemo } from 'react'
import { Modal, Space } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import PaymentCheckout from './PaymentCheckout'
import './PaymentModal.css'

const PaymentModal = ({
  open,
  clientSecret,
  taskId,
  amount,
  currency,
  researchDepth,
  analystCount,
  onSuccess,
  onCancel,
}) => {
  const shouldRender = useMemo(() => open, [open])

  return (
    <Modal
      open={open}
      title={
        <Space size={10} align="center" className="payment-modal__title">
          <CheckCircleOutlined className="payment-modal__title-icon" />
          <span>Complete Payment</span>
        </Space>
      }
      footer={null}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      centered
      width={580}
      className="payment-modal"
    >
      {shouldRender && (
        <PaymentCheckout
          clientSecret={clientSecret}
          taskId={taskId}
          amount={amount}
          currency={currency}
          researchDepth={researchDepth}
          analystCount={analystCount}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      )}
    </Modal>
  )
}

export default PaymentModal
